import React from 'react';
import classNames from 'classnames';

import './index.scss';

export default function ButtonGroup({className, vertical, children}) {
    const classes = classNames('button-group', className, {
        'button-group--vertical': vertical,
        'button-group--horizontal': !vertical
    });

    return <div className={classes}>{children}</div>;
}



// WEBPACK FOOTER //
// ./components/button_group/index.js